import {Component, inject, signal} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EmailConfirmIconComponent} from '@core/svg-icons/email-confirm-icon.component';
import {LoadingComponent} from '@layout/components/general/loading/loading.component';
import {UserService} from '@core/services/user.service';

@Component({
  selector: 'app-confirm-account-modal',
  templateUrl: './confirm-account-modal.component.html',
  styleUrls: ['./confirm-account-modal.component.scss'],
  imports: [
    ModalContainerComponent,
    EmailConfirmIconComponent,
    LoadingComponent,
    NgbAlert
  ]
})
export class ConfirmAccountModalComponent {
  private modalService = inject(NgbModal);
  private userService = inject(UserService);


  email = '';
  message: string | undefined = undefined;

  emailResend = signal(false);
  loading = signal(false);

  sendConfirmationEmail() {
    this.loading.set(true);
    this.userService.sendEmailConfirmation(this.email).then(x => {
      this.loading.set(false);
      this.emailResend.set(true);
    }).catch(() => {
      this.loading.set(false);
    });
  }

  goToLogin() {
    this.modalService.dismissAll();
    import('../login-modal/login-modal.component').then(({LoginModalComponent}) => {
      const email = this.email;
      const modalReference = this.modalService.open(LoginModalComponent);
      if (email) {
        modalReference.componentInstance.email = email;
      }
    });
  }

}
